import { createFileRoute } from "@tanstack/react-router";
import { RoutesListPage } from "~/pages/routes/RoutesListPage";
export const Route = createFileRoute("/_authenticated/routes/")({ component: RoutesListPage });
